import {Component, OnInit, ViewChild} from '@angular/core';
import {AuthService} from 'src/app/service/autenticacao/auth.service';
import {FormBuilder, Validators} from '@angular/forms';
import {RequerimentoGeralComponent} from './requerimento-geral/requerimento-geral.component';
import {CpeService} from '../../../service/cpe/cpe.service';
import {OK_MANIFESTO_ENVIADO} from '../../../tools/Mensagens';
import {PAGINA_SUCESSO_FORM} from '../../../tools/URL';
import {Router} from '@angular/router';
import {ResponseHandler} from './model/Cpe';
import {DesarquivamentoAutosComponent} from './desarquivamento-autos/desarquivamento-autos.component';
import {ModalComponent} from "./shared/modal/modal.component";
import {CpeAbstract} from "./abstract/CpeAbstract";


@Component({
  selector: 'app-cpe',
  templateUrl: './cpe.component.html',
  styleUrls: ['./cpe.component.css']
})
export class CpeComponent extends CpeAbstract implements OnInit {

  @ViewChild(RequerimentoGeralComponent, {static: false}) requerimentoGeral: RequerimentoGeralComponent;
  @ViewChild(DesarquivamentoAutosComponent, {static: false}) desarquivamentoAutosComponent: DesarquivamentoAutosComponent;
  @ViewChild(ModalComponent, { static: false }) modalComponent!: ModalComponent;


  tituloModal: string = '';
  conteudoModal: string = '';
  textoBotaoPrimarioModal: string = '';
  mostrarBotaoSecondario: boolean = false;

  protected tituloPrincipalPagina = 'Faça seu Requerimento';
  protected subTituloPagina = 'Formulário EXCLUSIVO para requerimento geral ou solicitação de desarquivamento de processos que tramitam nas Turmas Recursais que aderiram à Central de Processos Eletrônicos de Turmas Recursais – CPE-TR.';
  protected tipoRequerimentoGeral = '1';

  private modalAberto: boolean = false;
  private tipoModalAtual: 'ciencia' | 'envio' | null = null;


  protected formulario = this.formBuilder.group({
    tipoRequerimento: [this.tipoRequerimentoGeral, Validators.required],
    requerimentoGeral: this.formBuilder.group({}),
    desarquivamentoAutos: this.formBuilder.group({}),
    nome: [this.authService.usuarioDTO.nome, Validators.required],
    email: [this.authService.usuarioDTO.email, Validators.required]
  });
  private usuarioConfirmouCiencia: boolean;

  constructor(public authService: AuthService,
              private formBuilder: FormBuilder,
              private service: CpeService,
              private router: Router) {
    super();
  }

  ngOnInit() {
    this.mostrarRequerimentoGeral();
  }

  public mostrarTipoRequirementoPorTipoSelecionado(tipoRequerimento: string) {
    if (tipoRequerimento === '1') {
      this.mostrarRequerimentoGeral();
      this.mostrarDesaquirvamentoAutos = false;
    } else {
      this.mostrarDesaquirvamentoAutos = true;
      this.mostrarRequerimentogeral = false;
    }
  }


  onSubmit() {
    const formularioValido = this.validarFormulario();
    if (formularioValido) {
      this.abrirPopupConfirmacaoEnvio();
    }

  }

  private processarEnvio() {
    this.service.salvar(this.formulario.value).subscribe((retorno: ResponseHandler[]) => {
      if (retorno && retorno.length > 0) {
        // Extrai e exibe todas as mensagens de erro
        const mensagens = retorno.map(error => error.mensagem).join('\n');
        alert(mensagens);
      } else {
        alert(OK_MANIFESTO_ENVIADO);
        this.router.navigate([PAGINA_SUCESSO_FORM]);
      }
    });
  }


  private validarFormulario(): boolean {
    this.gerarAlertaUsuarioAutenticado();
    if (this.formulario.get('tipoRequerimento').value === this.tipoRequerimentoGeral) {
      this.validarFormularioRequerimentoGeral();
    } else {
      this.validarFormularioDesarquivamentoAutos();
    }
    this.gerarAlertaFormularioStatusInvalid();
    return this.formulario.valid;
  }

  private validarFormularioRequerimentoGeral() {
    if (this.requerimentoGeral) {
      this.requerimentoGeral.validarFormulario();
    }
  }

  private validarFormularioDesarquivamentoAutos() {
    if (this.desarquivamentoAutosComponent) {
      this.desarquivamentoAutosComponent.validarFormulario();
    }
  }

  private gerarAlertaFormularioStatusInvalid() {
    if (!this.formulario.valid) {
      alert('O formulário não foi validado em todos os critérios de aceitação');
    }
  }

  private gerarAlertaUsuarioAutenticado() {
    if (!this.formulario.get('nome').valid) {
      alert('Não foi possível indentificar o nome do usuário autenticado, favor sair e logar novamente');
    }
    if (!this.formulario.get('email').valid) {
      alert('Não foi possível indentificar o e-mail do usuário autenticado, favor sair e logar novamente');
    }
  }

  private mostrarRequerimentoGeral() {
    if (!this.usuarioConfirmouCiencia) {
      this.abrirPopupConfirmarCienciaRequerimentoGeral();
    } else {
      this.mostrarRequerimentogeral = true;
    }
  }

  private abrirPopupConfirmarCienciaRequerimentoGeral() {
    this.tipoModalAtual = 'ciencia';
    this.tituloModal = 'Atenção';
    this.conteudoModal = `
      <p> Informamos que este canal é exclusivo para processos que tramitam nas TURMAS RECURSAIS que aderiram à Central de Processos Eletrônicos de Turmas Recursais – CPE-TR.</p>
      <p>Para informações, reclamações ou outras solicitações referentes a processos que NÃO tramitam na CPE-TR, retorne ao Menu anterior e escolha o tema adequado a sua solicitação.</p>
      <p>Para prosseguir, clique em “Ciente”.</p>
    `;
    this.textoBotaoPrimarioModal = 'Ciente';

    setTimeout(() => {
      if (this.modalComponent && !this.modalAberto) { // VERIFICAR SE NÃO ESTÁ ABERTO
        this.modalComponent.abrirModal();
        this.modalAberto = true; // MARCAR COMO ABERTO
      }
    }, 100);
  }

  confirmarLeituraPopup() {
    if (this.tipoModalAtual === 'ciencia') {
      this.usuarioConfirmouCiencia = true;
      this.mostrarRequerimentogeral = true;
    } else if (this.tipoModalAtual === 'envio') {
      this.processarEnvio();
    }

    this.fecharModalSeAberto();
    this.tipoModalAtual = null;
  }

  private fecharModalSeAberto() {
    if (this.modalAberto && this.modalComponent) {
      this.modalComponent.fecharModal();
      this.modalAberto = false;
    }
  }

  abrirPopupConfirmacaoEnvio() {
    this.mostrarBotaoSecondario = true;
    this.tipoModalAtual = 'envio';
    this.tituloModal = 'Atenção';
    this.conteudoModal = `
      <p>Este canal é exclusivo para processos que tramitam nas Turmas Recursais que aderiram à Central de Processos Eletrônicos de Turmas Recursais – CPE-TR.</p>
      <p>Para informações, reclamações ou outras solicitações referentes a processos que NÃO tramitam na CPE-TR, retorne à página principal e escolha o tema adequado a sua demanda.</p>
    `;
    this.textoBotaoPrimarioModal = 'Confirmar solicitação';

    setTimeout(() => {
      if (this.modalComponent && !this.modalAberto) { // VERIFICAR SE NÃO ESTÁ ABERTO
        this.modalComponent.abrirModal();
        this.modalAberto = true;
      }
    }, 100);
  }

  cancelarEnvioRequisicao() {
    this.fecharModalSeAberto();
  }

}
